import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import ApiService from '../../../services/ApiService'
import { setCookies } from '../../../utility/Cookies'
import { encryptCrypto } from '../../../utility/Encryption'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorAccountUpdate = () => {
  const { t } = useTranslation()
  const { seller } = useSelector((state) => state.seller)
  const accountUpdate = useCallback(
    (payload, callback = () => {}) => {
      const {
        account_email_address,
        company_information,
        company_logo,
        company_name,
        is_deleted,
        product_sold,
        store_rating,
        store_total_review,
        taxType,
        ...requestPayload
      } = payload
      ApiService.jsonRequest('/store-account/update', requestPayload, (response) => {
        if (response.status_code === 200) {
          callback(response.data)
          const objectSeller = {
            ...seller,
            address: payload.address,
            address_detail: payload.address_detail,
            city_uid: payload.city_uid,
            country_uid: payload.country_uid,
            district_uid: payload.district_uid,
            postal_code_uid: payload.postal_code_uid,
            province_uid: payload.province_uid,
            store_description: payload.store_description,
            store_logo: payload.store_logo,
            store_name: payload.store_name,
            subdistrict_uid: payload.subdistrict_uid,
          }
          setCookies({
            key: '_wssc',
            value: encryptCrypto(JSON.stringify(objectSeller)),
            expires: new Date().getTime() + 8 * 3600 * 1000, // 8 Hours
          })
          showAlert({
            icon: 'success',
            message: t('message.store_success_update'),
            timer: 3000,
            reload: true,
          })
        } else {
          showAlert({ icon: 'error', message: t('message.store_failed_update'), timer: 3000 })
        }
      })
    },
    [seller, t],
  )

  return { accountUpdate }
}

export default InteractorAccountUpdate
